import React from "react";
import classes from "./About.module.css";
const About = () => {
  return (
    <div className={classes.Intro}>
      <h1 className={classes.focusLine}>
        <span>ABOUT AMPLIFY</span>
      </h1>
      <div className={classes.container1}>
        <p>
          At Amplify, our patients are at the center of all we do. We strive to
          go beyond treating your symptoms, and focus on understanding all
          aspects of your lifestyle to ensure we are identifying and addressing
          the root cause of your pain or discomfort. We spend time to ensure our
          patients understand their pain and what self-management techniques are
          available to them.
        </p>
        <ul>
          <li>
            <b>Compassion</b> - to respect and listen to your concerns and questions.{" "}
          </li>
          <li>
            <b>Trustworthiness</b> - to create the room and space for establishing
            mutual trust.
          </li>
          <li>
            <b>Empathy</b> - to put ourselves in our patients’ shoes and understand
            their perspectives.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default About;
